import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';

import {
  DOCUMENT_SECTIONS,
  DOCUMENT_TYPE_LABEL_KEYS,
  STATUS_UI_MAP,
  YEAR_SUFFIXED_DOCUMENT_TYPES,
} from './constants';

export const getStatusUi = (status) => STATUS_UI_MAP[status] || STATUS_UI_MAP.UNKNOWN;

export const getDocumentTitle = (document) => {
  const labelKey = DOCUMENT_TYPE_LABEL_KEYS[document?.documentType];
  const baseLabel = labelKey ? LanguageConverterV2(labelKey) : document?.documentType;

  if (
    YEAR_SUFFIXED_DOCUMENT_TYPES.includes(document?.documentType) &&
    document?.metadata?.createdAt
  ) {
    const year = new Date(document.metadata.createdAt).getFullYear();
    return `${baseLabel} (${year})`;
  }

  return baseLabel;
};

export const buildSections = (onboardingDocuments) =>
  DOCUMENT_SECTIONS.map((section) => ({
    ...section,
    documents:
      section.key === 'other'
        ? onboardingDocuments?.uncategorized || []
        : (section.types || []).flatMap((type) => onboardingDocuments?.[type] || []),
  }));
